<template>
	<div
		id='vehicles-list'
		ref='list'
		v-resize='getCols'
		style='width: 100%'
	>
		<LoadingSpinner v-if='loading' text='Fahrzeuge werden geladen...' />

		<!--    tile view start -->
		<v-row v-if='loading && !isList' class='px-1'>
			<v-col
				v-for='index in skeletonsCount'
				:key='index'
				:cols='cardCols'
				class='pa-2'
			>
				<vehicle-card-skeleton />
			</v-col>
		</v-row>

		<v-row v-if='topVehicle'>
			<v-col class='py-0 mb-n6'>
				<vehicle-list-card :vehicle='topVehicle' :large-solo='largeSoloCard' />
			</v-col>
		</v-row>

		<v-row v-if='vehicles.length > 0 && !loading && !isList'>
			<v-col
				v-for='(vehicle, position) in vehicles'
				:key='vehicle.id'
				:cols='cardCols'
			>
				<vehicle-card :vehicle='vehicle' :large-solo='largeSoloCard' :position-catalog='position+1' />
			</v-col>
		</v-row>
		<!--    tile view end -->

		<!-- list view start    -->
		<v-row v-if='vehicles.length > 0 && !loading && isList'>
			<v-col>
				<vehicle-list-card
					v-for='(vehicle, position) in vehicles'
					:key='vehicle.id'
					:vehicle='vehicle'
					:position-catalog='position+1'
				/>
			</v-col>
		</v-row>
		<!-- list view end    -->

		<div v-if='vehicles.length <= 0 && !loading' class='py-1 mt-2 text-center font-weight-bold font-size-large'>
			<v-card
				class='shadow large-solo pa-4'
			>
				Leider haben wir kein Fahrzeug im Angebot, das zu deinen ausgewählten Filtern passt. <br>Passe den Filter an oder lösche alle angewandten Filter.
			</v-card>
		</div>

		<v-row
			v-if='$store.pagination.total > 0'
			align='center'
			class='mt-2'
			dense
			justify='space-between'
		>
			<v-col cols='12' lg='4'>
				<v-row
					align='center'
					justify='center'
					justify-lg='start'
					no-gutters
				>
					<div style='width: 156px; max-width: 156px'>
						Fahrzeuge pro Seite:
					</div>

					<select-component
						v-model='$store.pagination.per_page'
						:options='perPageItems'
						class='light-input'
						title='Fahrzeuge pro Seite:'
						width='66px'
					/>
				</v-row>
			</v-col>

			<v-col class='text-center text-lg-right' cols='12' lg='8'>
				<v-pagination
					v-model='$store.pagination.page'
					:length='$store.pagination.last_page'
					:total-visible='7'
					class='no-text-highlight'
					next-icon='fas fa-chevron-right'
					prev-icon='fas fa-chevron-left'
					@input='scrollToTop'
				/>
			</v-col>

			<v-col class='text-center text-lg-right primary--text text--lighten-2' style='font-size: 13px' cols='12'>
				{{ pagination.from }} - {{ pagination.to }} von {{ $store.pagination.total }} Fahrzeugen werden angezeigt
			</v-col>
		</v-row>
	</div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner'
import SelectComponent from './SelectComponent'
import VehicleCard from './VehicleCard'
import VehicleCardSkeleton from '@/components/VehicleCardSkeleton'
import VehicleListCard from '@/components/VehicleListCard';

export default {
	name: 'VehiclesList',

	components: {VehicleListCard, VehicleCardSkeleton, VehicleCard, SelectComponent, LoadingSpinner},

  props: {
    isList: {
	    default: false,
      required: false,
      type: Boolean
    }
  },

	data() {
		return {
      topVehicle: null,
			largeSoloCard: false,
			cardCols: 12,
			loading: true,
			vehicles: [],
			perPageItems: [15, 30, 60, 90],
			skeletonsCount: 15
		}
	},
  computed: {
    pagination() {
      const { per_page, page,last_page, total } = this.$store.pagination
      return {
        from: per_page * page - per_page + 1,
        to: last_page !== page ? per_page * page : total
      }
    }
  },
	watch: {
		'$store.pagination.per_page'(newValue, oldValue) {
			if (newValue !== oldValue) {
				this.$store.pagination.page = 1
				this.getSkeletonsCount()
				this.doRender()
			}
		},
		'$store.pagination.page'(newValue, oldValue) {
			if (newValue !== oldValue) {
				this.getSkeletonsCount(newValue, oldValue)
				this.doRender()
			}
		},
		'$store.sortBy'(newValue, oldValue) {
			if (newValue !== oldValue) this.doRender()
		}
	},

	async mounted() {
		this.getSkeletonsCount()

		await this.doRender()

		this.$bus.$on('filters-updated', async () => {
			this.$store.pagination.page = 1
			this.getSkeletonsCount()
      this.scrollToTop();
      await this.doRender()
		})
	},

	methods: {
	  scrollToTop() {
      document.body.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })

    },
		async doRender() {
			this.getCols()

			this.loading = true

      this.topVehicle = null

      fetch(process.env.VUE_APP_API_ENDPOINT + 'vehicles/top-vehicle')
          .then(response => response.json())
          .then(data => {
            if(data && typeof data.error === 'undefined') {
              this.topVehicle = data
            }
          });
      
			await this.getVehicles()

			this.loading = false

			this.$bus.$emit('vehicles-list-updated', this.vehicles)
		},

		getCols() {
			let largeSoloCard = false
			let cardCols = 12

			if (this.$refs['list']) {
				const list_width = this.$refs['list'].clientWidth
				const card_width = 282
				const large_card_width = 338

				if (card_width * 3 <= list_width) {
					if (large_card_width * 3 < list_width) largeSoloCard = true
					cardCols = 4
				} else if (card_width * 2 <= list_width) {
					if (large_card_width * 2 < list_width) largeSoloCard = true
					cardCols = 6
				} else if (large_card_width < list_width) largeSoloCard = true
			}

			this.largeSoloCard = largeSoloCard
			this.cardCols = cardCols
		},

		async getVehicles() {
			this.vehicles = await this.$store.actions.getVehicles()
		},

		getSkeletonsCount(newPage = undefined, oldPage = undefined) {
			let count = this.$store.pagination.per_page

			if (oldPage && newPage && newPage > oldPage && newPage === this.$store.pagination.last_page) {
				count = this.$store.pagination.total - (this.$store.pagination.per_page * (this.$store.pagination.last_page - 1))
			}

			this.skeletonsCount = count
		}
	}
}
</script>

<style>
.theme--light .v-pagination__navigation {
  height: 38px;
  margin: 0.3rem;
  min-width: 38px;
}
.theme--light .v-pagination__navigation:hover {
  font-weight: bold;
  color: black;
}
.theme--light.v-pagination .v-pagination__item--active {
  background-color: #fff !important;
  font-weight: bold;
  color: #000;
  border-radius: 3px !important;
  box-shadow: 0 0 3px 1px rgba(185, 185, 185, 0.28) !important;
  border: 1px solid rgba(185, 185, 185, 0.4) !important;
}
.v-pagination__navigation {
  border-radius: 3px !important;
  box-shadow: 0 0 3px 1px rgba(185, 185, 185, 0.28) !important;
  border: 1px solid rgba(185, 185, 185, 0.4) !important;
}
.v-pagination__item:hover {
  font-weight: bold;
}
.v-pagination__item {
  border-radius: 3px !important;
  box-shadow: 0 0 3px 1px rgba(185, 185, 185, 0.28) !important;
  border: 1px solid rgba(185, 185, 185, 0.4) !important;
}
</style>
<style scoped>
#vehicles-list {
	width: 870px;
}
</style>
